// Campus photo for /colleges/university-of-hawaii-at-manoa: CC BY-SA 4.0, by Historyrus82, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AHawai'i_Hall.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-hawaii-at-manoa/; credited under the photo.
const photo = {
    "slug": "university-of-hawaii-at-manoa",
    "alt": "Hawaii Hall with its columned entrance behind palms and a lawn on the University of Hawaii at Manoa campus in Honolulu",
    "src": "/colleges/university-of-hawaii-at-manoa/campus-1600.webp",
    "srcSmall": "/colleges/university-of-hawaii-at-manoa/campus-800.webp",
    "srcMid": "/colleges/university-of-hawaii-at-manoa/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-hawaii-at-manoa/og.jpg",
    "title": "Hawai'i Hall",
    "author": "Historyrus82",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AHawai'i_Hall.jpg",
    "read": "2026-10-02"
};

export default photo;
